<!-- Skeleton Loading State -->
<div *ngIf="isLoading" class="max-w-[1440px] mx-auto px-4 md:px-8 py-6 md:py-10" style="font-family: sans-serif;">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12">
    <!-- Left: Image skeleton -->
    <div>
      <div class="w-full aspect-[4/3] rounded-2xl bg-gray-200 animate-pulse"></div>
      <div class="flex gap-3 mt-3">
        <div class="w-[120px] h-[70px] md:w-[160px] md:h-[90px] rounded-md bg-gray-200 animate-pulse"></div>
        <div class="w-[120px] h-[70px] md:w-[160px] md:h-[90px] rounded-md bg-gray-200 animate-pulse"></div>
        <div class="w-[120px] h-[70px] md:w-[160px] md:h-[90px] rounded-md bg-gray-200 animate-pulse"></div>
        <div class="w-[120px] h-[70px] md:w-[160px] md:h-[90px] rounded-md bg-gray-200 animate-pulse hidden md:block">
        </div>
      </div>
    </div>
    <!-- Right: Details skeleton -->
    <div class="space-y-5">
      <!-- Title -->
      <div class="space-y-2">
        <div class="h-8 bg-gray-200 rounded-lg w-3/4 animate-pulse"></div>
        <div class="h-4 bg-gray-100 rounded w-1/3 animate-pulse"></div>
      </div>
      <!-- Price -->
      <div class="flex items-center gap-3">
        <div class="h-5 bg-gray-100 rounded w-16 animate-pulse"></div>
        <div class="h-8 bg-gray-200 rounded-lg w-32 animate-pulse"></div>
        <div class="h-6 bg-green-100 rounded-full w-20 animate-pulse"></div>
      </div>
      <!-- Surface Type -->
      <div class="space-y-2">
        <div class="h-3 bg-gray-100 rounded w-24 animate-pulse"></div>
        <div class="flex gap-2 flex-wrap">
          <div class="h-9 w-24 bg-gray-200 rounded-full animate-pulse"></div>
          <div class="h-9 w-28 bg-gray-200 rounded-full animate-pulse"></div>
          <div class="h-9 w-24 bg-gray-200 rounded-full animate-pulse"></div>
          <div class="h-9 w-20 bg-gray-200 rounded-full animate-pulse"></div>
          <div class="h-9 w-28 bg-gray-100 rounded-full animate-pulse"></div>
          <div class="h-9 w-20 bg-gray-100 rounded-full animate-pulse"></div>
        </div>
      </div>
      <!-- Size Type -->
      <div class="space-y-2">
        <div class="h-3 bg-gray-100 rounded w-20 animate-pulse"></div>
        <div class="flex gap-2">
          <div class="h-10 w-24 bg-gray-200 rounded-full animate-pulse"></div>
          <div class="h-10 w-24 bg-gray-100 rounded-full animate-pulse"></div>
          <div class="h-10 w-28 bg-gray-100 rounded-full animate-pulse"></div>
        </div>
      </div>
      <!-- Wall dimensions -->
      <div class="space-y-2">
        <div class="h-3 bg-gray-100 rounded w-28 animate-pulse"></div>
        <div class="flex gap-2">
          <div class="h-10 flex-1 bg-gray-200 rounded-lg animate-pulse"></div>
          <div class="h-10 flex-1 bg-gray-200 rounded-lg animate-pulse"></div>
          <div class="h-10 w-24 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>
      </div>
      <!-- Price summary -->
      <div class="h-20 bg-green-50 rounded-xl animate-pulse"></div>
      <!-- Buttons -->
      <div class="flex gap-3">
        <div class="h-12 flex-1 bg-[#600b0b]/20 rounded-xl animate-pulse"></div>
        <div class="h-12 flex-1 bg-gray-200 rounded-xl animate-pulse"></div>
      </div>
    </div>
  </div>
</div>

<!-- Error state -->
<div *ngIf="!isLoading && loadError" class="min-h-screen flex items-center justify-center">
  <div class="text-center space-y-4">
    <p class="text-gray-400 text-lg" style="font-family: 'Roboto Slab', serif;">Could not load wallpaper details.
    </p>
    <button (click)="navigateToListing()"
      class="bg-[#600b0b] text-white px-6 py-3 rounded-xl font-bold uppercase tracking-wider text-xs hover:bg-[#8c1c1c] transition-all">Browse
      All Wallpapers</button>
  </div>
</div>

<!-- PDP Content -->
<div *ngIf="!isLoading && wallpaper" class="page-transition" style="font-family: sans-serif;">

  <!-- Self Adhesive Toast -->
  <div *ngIf="selfAdhesiveMessage"
    class="fixed top-3 left-1/2 -translate-x-1/2 z-[200] bg-[#e74c3c] text-white text-xs md:text-sm font-semibold px-5 py-2.5 rounded shadow-xl flex items-center gap-3 max-w-[90vw]">
    <span>{{ selfAdhesiveMessage }}</span>
    <button (click)="selfAdhesiveMessage = ''" class="text-white/80 hover:text-white text-base shrink-0">✕</button>
  </div>

  
  <!-- Breadcrumb -->
  <div class="bg-[#faf8f5] border-b border-gray-100 py-2.5 md:py-0 px-3 md:px-6">
    <div class="max-w-[1440px] mx-auto flex items-center gap-2 text-[10px] text-gray-400 tracking-[0.15em]">
      <button (click)="router.navigate(['/'])" class="hover:text-[#600b0b] transition-colors shrink-0">Home</button>
      <span class="shrink-0">/</span>
      <button (click)="navigateToListing()" class="hover:text-[#600b0b] transition-colors shrink-0 hidden sm:inline">All
        Wallpapers</button>
      <span class="shrink-0 hidden sm:inline">/</span>
      <span class="text-gray-600  max-w-[150px] sm:max-w-none">{{ wallpaper.name }}</span>
    </div>
  </div>

  <div class="max-w-[1440px] mx-auto px-2 md:px-3 lg:px-4 py-1 md:py-2">
    <div class="grid grid-cols-1 lg:grid-cols-[3.5fr_1fr] gap-4 md:gap-6 overflow-hidden">

      <!-- ═══ LEFT: Images ═══ -->
      <div class="space-y-3 md:space-y-4 min-w-0 overflow-hidden">

        <!-- Image area: vertical thumb strip + main image -->
        <div class="flex gap-2 md:gap-3">

          <!-- Vertical thumbnail strip (LEFT) -->
          <div *ngIf="images.length > 1" class="hidden md:flex flex-col gap-2 shrink-0 w-[52px] lg:w-[60px] max-h-[560px] overflow-y-auto no-scrollbar">
            <div *ngFor="let img of images; let i = index" (click)="changeActiveImage(i)"
              class="shrink-0 cursor-pointer">
              <div
                [class]="'w-full aspect-[16/10] rounded-md overflow-hidden border-2 transition-all ' + (activeImageIndex === i ? 'border-[#c24a00] shadow-md' : 'border-gray-200 hover:border-gray-400')">
                <img [src]="img" [alt]="wallpaper.name" class="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          <!-- Main image -->
          <div
            class="group relative flex-1 min-w-0 rounded-xl md:rounded-2xl overflow-hidden shadow-lg cursor-zoom-in bg-[#f5f0eb]"
            (click)="isZoomed = !isZoomed">
            <img [src]="activeImage" [alt]="wallpaper.name"
              class="w-full h-auto block transition-transform duration-500"
              [style.transform]="isZoomed ? 'scale(1.6)' : 'scale(1)'" />

            <!-- Left / Right arrows on main image -->
            <button *ngIf="images.length > 1 && !isZoomed" (click)="prevImage(); $event.stopPropagation()"
              class="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center transition-transform hover:scale-110">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 md:w-7 md:h-7 text-white drop-shadow-md" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
            </button>
            <button *ngIf="images.length > 1 && !isZoomed" (click)="nextImage(); $event.stopPropagation()"
              class="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center transition-transform hover:scale-110">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 md:w-7 md:h-7 text-white drop-shadow-md" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
            </button>

            <div *ngIf="wallpaperType === 'premium' || wallpaperType === 'Premium'"
              class="absolute top-3 left-3 md:top-4 md:left-4 z-10 bg-[#c49a6c] text-white text-[8px] md:text-[9px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow">
              Premium
            </div>

            <!-- Top fade gradient on hover (backdrop for action icons) -->
            <div class="absolute top-0 left-0 right-0 h-20 md:h-24 bg-gradient-to-b from-black/60 via-black/20 to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-[5]"></div>

            <!-- Top-right action buttons: wishlist + crop + fullscreen (hover only) -->
            <div class="absolute top-3 right-3 md:top-4 md:right-4 flex items-center gap-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" (click)="$event.stopPropagation()">
              <!-- Wishlist -->
              <button (click)="toggleWishlist(); $event.stopPropagation()"
                [title]="isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'"
                class="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center transition-transform hover:scale-110"
                [class.text-white]="!isWishlisted"
                [class.text-[#600b0b]]="isWishlisted">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 md:w-[22px] md:h-[22px]" viewBox="0 0 24 24"
                  [attr.fill]="isWishlisted ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
              </button>
              <!-- Crop preview button -->
              <!-- <button (click)="openCropModal(); $event.stopPropagation()"
                title="Crop pattern to wall size"
                class="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center transition-transform text-white hover:scale-110">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 md:w-[22px] md:h-[22px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 2v14a2 2 0 002 2h14M2 6h14a2 2 0 012 2v14"/>
                </svg>
              </button> -->
              <!-- Fullscreen expand button -->
              <button (click)="openLightbox(); $event.stopPropagation()"
                title="View fullscreen"
                class="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center transition-transform text-white hover:scale-110">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 md:w-[22px] md:h-[22px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Mobile horizontal thumb strip (below main image, tablet/phone only) -->
        <div *ngIf="images.length > 1" class="md:hidden relative mt-3">
          <div #thumbStrip class="flex gap-2 overflow-x-auto no-scrollbar pb-1 scroll-smooth">
            <div *ngFor="let img of images; let i = index" (click)="changeActiveImage(i)"
              class="shrink-0 cursor-pointer w-[64px]">
              <div
                [class]="'w-full aspect-[16/10] rounded-md overflow-hidden border-2 transition-all ' + (activeImageIndex === i ? 'border-[#c24a00] shadow-md' : 'border-gray-200')">
                <img [src]="img" [alt]="wallpaper.name" class="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>

        <!-- Title + SKU + variant circles row (below image) -->
        <div class="flex items-start justify-between gap-4 px-1">
          <div class="min-w-0">
      
          </div>
          <!-- Variant color circles -->
          <div *ngIf="variantColors.length > 1" class="flex items-center gap-2 shrink-0 pt-1.5 pb-1">
            <button *ngFor="let v of variantColors; let i = index" (click)="changeVariant(i)"
              [title]="'Variant ' + (i+1)"
              [class]="'w-7 h-7 md:w-8 md:h-8 rounded-full overflow-hidden border-2 transition-all shrink-0 ' +
               (selectedColorIndex === i ? 'border-[#600b0b] scale-110 shadow-md' : 'border-gray-300 hover:border-gray-500')">
              <img [src]="v.image" [alt]="'Variant ' + (i+1)" class="w-full h-full object-cover" />
            </button>
          </div>
        </div>

      </div>

      <!-- ═══ RIGHT: Purchase Panel ═══ -->
      <div class="divide-y divide-gray-100 lg:row-span-2">

        <!-- Sections hidden when "Order a Sample" is open — desktop only.
             On mobile the sample expands inline (like Expert Visit), so keep them visible. -->
        <ng-container *ngIf="!showSampleDetail || isMobile">

        <!-- Price row -->
        <div class="pb-3">
          <!-- Collection type — same colours as the ribbon on the listing cards,
               so the badge the customer clicked through from is recognisable here. -->
          <div *ngIf="collectionTypeLabel" class="mb-2">
            <span
              [class]="'inline-block text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded ' + collectionTypeClass">
              {{ collectionTypeLabel }}
            </span>
          </div>
          <div *ngIf="selectedSizeType !== 'SAMPLE'" class="flex items-baseline gap-2 flex-wrap">
            <ng-container *ngIf="papersLoaded && !priceLoading">
              <span>From</span>
              <!-- Struck-through rate only when it differs from what is charged;
                   wallpapers carry no flat discount, so the two are equal. -->
              <span *ngIf="surfaceOriginalPrice - perSqFtDisplay > 0.01"
                class="text-base text-gray-400 line-through"> ₹{{ surfaceOriginalPrice }}</span>
              <span class="text-xl font-bold text-gray-900">₹{{ perSqFtDisplay | number:'1.2-2' }}<span class="text-xs font-normal text-gray-500">/sq.ft.</span></span>
            </ng-container>
            <ng-container *ngIf="!papersLoaded || priceLoading">
              <div class="flex items-center gap-2">
                <div class="h-5 w-16 bg-gray-200 rounded animate-pulse"></div>
                <div class="h-7 w-28 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="selectedSizeType === 'SAMPLE'" class="text-sm font-medium text-gray-700">Sample Order</div>
        </div>

        <!-- Step 1: YOUR WALL SIZE -->
        <div class="py-3">
          <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-gray-400 mb-2.5">Your Wall Size</p>

          <!-- Sample Options (visible when SAMPLE selected) -->
          <div *ngIf="selectedSizeType === 'SAMPLE'" class="space-y-3">
            <p class="text-[11px] text-gray-600">Choose one or more surfaces to receive as samples.</p>
            <div *ngIf="papersLoaded" class="grid grid-cols-2 gap-2">
              <button *ngFor="let paper of papers" type="button"
                (click)="toggleSampleSurface(paper)"
                [ngClass]="{
                  'border-[#600b0b] bg-[#fbf3f3] text-[#600b0b]': isSampleSurfaceSelected(paper),
                  'border-gray-200 bg-white text-gray-700 hover:border-gray-400': !isSampleSurfaceSelected(paper)
                }"
                class="flex items-center gap-2 px-3 py-2 rounded-lg border-2 transition-all text-left">
                <span class="w-4 h-4 rounded-sm border-2 flex items-center justify-center shrink-0 transition-colors"
                  [class.border-[#600b0b]]="isSampleSurfaceSelected(paper)"
                  [class.bg-[#600b0b]]="isSampleSurfaceSelected(paper)"
                  [class.border-gray-300]="!isSampleSurfaceSelected(paper)">
                  <svg *ngIf="isSampleSurfaceSelected(paper)" xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span class="text-[11px] font-semibold">{{ paper.display_name || paper.name || paper.title }}</span>
              </button>
            </div>
            <div *ngIf="!papersLoaded" class="grid grid-cols-2 gap-2">
              <div class="h-10 bg-gray-100 rounded-lg animate-pulse"></div>
              <div class="h-10 bg-gray-100 rounded-lg animate-pulse"></div>
            </div>
            <p class="text-xs text-[#600b0b] font-medium">
              <ng-container *ngIf="selectedSampleSurfaceIds.size > 0">{{ selectedSampleSurfaceIds.size }} surface{{ selectedSampleSurfaceIds.size > 1 ? 's' : '' }} selected</ng-container>
              <ng-container *ngIf="selectedSampleSurfaceIds.size === 0">Select surfaces for your sample kit</ng-container>
            </p>
            <button (click)="selectSizeType('CUSTOM')" class="text-xs text-[#600b0b] hover:underline flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
              Back to custom sizing
            </button>
          </div>

          <!-- Standard Size Options -->
          <div *ngIf="selectedSizeType === 'STANDARD'" class="space-y-2 mb-3">
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let size of standardSizes" (click)="selectStandardSize(size)"
                [class]="'px-3 py-1.5 rounded-full text-[9px] font-semibold transition-all border ' + (selectedStandardSize?.label === size.label ? 'bg-[#600b0b] text-white border-[#600b0b]' : 'border-gray-300 text-gray-700 hover:border-gray-500')">
                {{ size.label }}
              </button>
            </div>
            <p class="text-[11px] text-[#600b0b]">Selected: {{ selectedStandardSize.label }} ({{ selectedStandardSize.area }} sq.ft)</p>
          </div>

          <!-- Custom wall dimensions -->
          <div *ngIf="selectedSizeType !== 'SAMPLE'" class="space-y-3">
            <div *ngFor="let wall of walls; let i = index">
              <div *ngIf="walls.length > 1" class="flex items-center justify-between mb-1.5">
                <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Wall {{ i + 1 }}</span>
                <button (click)="removeWall(i)" class="text-gray-300 hover:text-red-500 transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
              <div class="grid grid-cols-2 gap-2 mb-1">
                <span class="text-[10px] text-gray-400"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="21 12 3 12"></polyline><polyline points="7 8 3 12 7 16"></polyline><polyline points="17 8 21 12 17 16"></polyline></svg>Width</span>
                <span class="text-[10px] text-gray-400"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="12 3 12 21"></polyline><polyline points="8 7 12 3 16 7"></polyline><polyline points="8 17 12 21 16 17"></polyline></svg>Height</span>
              </div>
              <div class="grid grid-cols-2 gap-2">
                <div class="flex items-stretch border border-gray-300 rounded-lg overflow-hidden focus-within:border-gray-500 transition-colors bg-white">
                  <div class="relative flex-1 flex items-center">
                    <input [(ngModel)]="wall.widthFt" (ngModelChange)="updateWallDim(wall)"
                      type="text" inputmode="numeric" pattern="[0-9]*" placeholder="-"
                      class="no-spinner w-full pl-3 pr-1 py-2.5 text-sm text-gray-900 bg-transparent outline-none" />
                    <span class="pr-2 text-[10px] text-gray-400 shrink-0">ft</span>
                  </div>
                  <div class="w-px bg-gray-200 self-stretch"></div>
                  <div class="relative flex items-center w-14">
                    <input [(ngModel)]="wall.widthIn" (ngModelChange)="updateWallDim(wall)"
                      (blur)="normalizeInches(wall, 'width')"
                      type="text" inputmode="numeric" pattern="[0-9]*" placeholder="-"
                      class="no-spinner w-full pl-2 pr-1 py-2.5 text-sm text-gray-900 bg-transparent outline-none" />
                    <span class="pr-2 text-[10px] text-gray-400 shrink-0">in</span>
                  </div>
                </div>
                <div class="flex items-stretch border border-gray-300 rounded-lg overflow-hidden focus-within:border-gray-500 transition-colors bg-white">
                  <div class="relative flex-1 flex items-center">
                    <input [(ngModel)]="wall.heightFt" (ngModelChange)="updateWallDim(wall)"
                      type="text" inputmode="numeric" pattern="[0-9]*" placeholder="-"
                      class="no-spinner w-full pl-3 pr-1 py-2.5 text-sm text-gray-900 bg-transparent outline-none" />
                    <span class="pr-2 text-[10px] text-gray-400 shrink-0">ft</span>
                  </div>
                  <div class="w-px bg-gray-200 self-stretch"></div>
                  <div class="relative flex items-center w-14">
                    <input [(ngModel)]="wall.heightIn" (ngModelChange)="updateWallDim(wall)"
                      (blur)="normalizeInches(wall, 'height')"
                      type="text" inputmode="numeric" pattern="[0-9]*" placeholder="-"
                      class="no-spinner w-full pl-2 pr-1 py-2.5 text-sm text-gray-900 bg-transparent outline-none" />
                    <span class="pr-2 text-[10px] text-gray-400 shrink-0">in</span>
                  </div>
                </div>
              </div>
              <!-- Multi-wall: a half-filled wall is not priced yet — say what it needs. -->
              <p *ngIf="walls.length > 1 && selectedSizeType === 'CUSTOM' && isWallPartial(wall)"
                class="mt-1 flex items-center gap-1 text-[10.5px] text-amber-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                Enter the {{ missingDimension(wall) }} to include this wall
              </p>
              <!-- The server could not price THIS wall — say why, under it. -->
              <p *ngIf="wallQuoteError(i) as wallError" role="alert"
                class="mt-1 flex items-start gap-1 text-[10.5px] font-medium text-red-600">
                <svg class="mt-px shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                {{ wallError }}
              </p>
            </div>
            <div *ngIf="canAddWall" class="flex justify-end">
              <button (click)="addWall()"
                class="inline-flex items-center gap-1 text-[#600b0b] text-[11px] font-medium hover:underline transition-all">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                Add another wall
              </button>
            </div>
          </div>
        </div>

        <!-- Step 2: SURFACE -->
        <div class="py-3">
          <div class="flex items-center justify-between mb-2">
            <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-gray-400">Surface</p>
            <button (click)="activeTab = 'specs'; scrollToSurfacesTab()" type="button"
              class="text-[10px] text-[#600b0b] hover:underline transition-colors">See details ↓</button>
          </div>
          <div *ngIf="!papersLoaded" class="flex flex-wrap gap-2">
            <div class="h-9 w-20 bg-gray-200 rounded-full animate-pulse"></div>
            <div class="h-9 w-32 bg-gray-200 rounded-full animate-pulse"></div>
            <div class="h-9 w-28 bg-gray-200 rounded-full animate-pulse"></div>
            <div class="h-9 w-24 bg-gray-100 rounded-full animate-pulse"></div>
          </div>
          <div *ngIf="papersLoaded" class="flex flex-wrap gap-2">
            <button *ngFor="let paper of papers"
              (click)="selectPaper(paper)"
              [ngClass]="{
                'bg-[#600b0b] text-white border-[#600b0b]': selectedPaper?.id === paper.id,
                'border-gray-300 text-gray-700 hover:border-[#600b0b] hover:text-[#600b0b]': selectedPaper?.id !== paper.id
              }"
              class="px-3 py-1.5 rounded-full text-[11px] font-semibold border transition-all">
              {{ paper.display_name || paper.name || paper.title }}
            </button>
          </div>
        </div>

        <!-- Price summary -->
        <div class="">
          <!-- The FIRST quote only: there is no earlier price to keep on screen. After
               that, a recalculation updates in place (see "Updating…" below). -->
          <div *ngIf="priceLoading && !pricingData" class="border border-gray-200 rounded-lg px-4 py-3 text-xs text-gray-500 flex items-center gap-2" role="status" aria-live="polite">
            <span class="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-300 border-t-[#600b0b]"></span>
            Calculating...
          </div>

          <!-- The quote was refused for a reason that is not one wall's (that one is shown under the wall). -->
          <div *ngIf="!priceLoading && !pricingData && quoteErrors.general && !hasWallQuoteErrors" role="alert"
            class="border border-red-200 bg-red-50 rounded-lg px-4 py-3 text-xs font-medium text-red-700">
            {{ quoteErrors.general }}
          </div>

          <!-- Multi-wall: one line per wall the quote priced (server `walls[]`), wallpaper only. -->
          <ng-template #wallLinesTpl>
            <div *ngIf="wallLines as lines" class="space-y-1 pb-1.5 mb-1.5 border-b border-dashed border-gray-200"
              [class.opacity-50]="priceUpdating">
              <div *ngFor="let l of lines" class="flex items-center justify-between text-[12px]">
                <span class="text-gray-600">{{ l.label }} <span class="text-gray-400">· {{ l.size }} ({{ l.area | number:'1.0-2' }} sq.ft.)</span></span>
                <span class="text-gray-900">₹{{ l.amount | number:'1.0-2' }}</span>
              </div>
            </div>
          </ng-template>

          <!-- Multi-wall: a half-filled wall is not in the price yet. -->
          <ng-template #notIncludedTpl>
            <p *ngIf="walls.length > 1 && notIncludedLabel" class="mt-1.5 flex items-center gap-1 text-[11px] text-amber-700">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {{ notIncludedLabel }}
            </p>
          </ng-template>

          <!-- Inline "Updating…" — the last valid price stays visible beside it. -->
          <ng-template #updatingTpl>
            <span *ngIf="priceUpdating" class="inline-flex items-center gap-1 text-[10.5px] font-normal text-gray-400" role="status" aria-live="polite">
              <span class="inline-block h-3 w-3 animate-spin rounded-full border-2 border-gray-300 border-t-[#600b0b]"></span>
              Updating…
            </span>
          </ng-template>

          <!-- The wallpaper's money, from the server quote: billed sq ft × the
               ex-GST rate, then GST on the taxable amount. -->
          <ng-template #wallpaperMoneyTpl>
            <ng-container *ngIf="calcReady && quoteSummary as q">
              <div class="flex items-center justify-between text-[12px]">
                <span class="text-gray-600">Wallpaper <span class="text-gray-400">({{ q.consumedSqft | number:'1.2-2' }} sq ft billable × ₹{{ q.rateExGst | number:'1.2-2' }}/sq ft excl. GST)</span></span>
                <span class="font-medium text-gray-900 tabular-nums transition-opacity" [class.opacity-50]="priceUpdating">₹{{ q.base | number:'1.2-2' }}</span>
              </div>
              <div *ngIf="q.discount > 0" class="flex items-center justify-between text-[12px]">
                <span class="text-gray-600">Discount</span>
                <span class="font-medium text-gray-900 tabular-nums">−₹{{ q.discount | number:'1.2-2' }}</span>
              </div>
              <div class="flex items-center justify-between text-[12px]">
                <span class="text-gray-600">GST ({{ q.gstPer }}%) <span class="text-gray-400">on ₹{{ q.taxable | number:'1.2-2' }}</span></span>
                <span class="font-medium text-gray-900 tabular-nums transition-opacity" [class.opacity-50]="priceUpdating">₹{{ q.gst | number:'1.2-2' }}</span>
              </div>
            </ng-container>
          </ng-template>

          <!-- No site service selected: one line, no breakdown -->
          <div *ngIf="!(priceLoading && !pricingData) && selectedSizeType !== 'SAMPLE' && (pricingData || totalWallArea > 0 || selectedSizeType === 'STANDARD') && !showServiceBreakdown"
            class="border border-gray-200 rounded-lg px-4 py-3 bg-[#faf8f5]">
            <ng-container *ngTemplateOutlet="wallLinesTpl"></ng-container>
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-700 flex items-center gap-2">Total: {{ totalWallArea | number:'1.0-2' }} sq.ft. <ng-container *ngTemplateOutlet="updatingTpl"></ng-container></span>
              <span class="font-bold text-gray-900 text-base transition-opacity" [class.opacity-50]="priceUpdating">{{ calcReady ? ('₹' + (calcTotal | number:'1.0-2')) : '—' }}</span>
            </div>
            <ng-container *ngTemplateOutlet="notIncludedTpl"></ng-container>
          </div>

          <!-- Installation OR expert visit selected: itemised -->
          <div *ngIf="!(priceLoading && !pricingData) && selectedSizeType !== 'SAMPLE' && (pricingData || totalWallArea > 0 || selectedSizeType === 'STANDARD') && showServiceBreakdown"
            class="border border-gray-200 rounded-lg px-4 py-3 bg-[#faf8f5] space-y-1.5">
            <ng-container *ngTemplateOutlet="wallLinesTpl"></ng-container>
            <ng-container *ngTemplateOutlet="wallpaperMoneyTpl"></ng-container>
            <ng-container *ngIf="calcInstallationAmount > 0">
              <div class="flex items-center justify-between text-[12px]">
                <span class="text-gray-600">Installation
                  <span class="text-gray-400">({{ installationBasisLabel }})</span>
                  <button type="button" (click)="showInstallDetail = true; showInstallInfo = true" class="ml-1 text-[10px] text-[#600b0b] underline">How?</button>
                </span>
                <span class="font-medium text-gray-900 tabular-nums transition-opacity" [class.opacity-50]="priceUpdating">₹{{ (quotedInstallation ? quotedInstallation.base : calcInstallationAmount) | number:'1.2-2' }}</span>
              </div>
              <div *ngIf="quotedInstallation && quotedInstallation.gst > 0" class="flex items-center justify-between text-[12px]">
                <span class="text-gray-600">Installation GST ({{ quotedInstallation.gstPer }}%)</span>
                <span class="font-medium text-gray-900 tabular-nums transition-opacity" [class.opacity-50]="priceUpdating">₹{{ quotedInstallation.gst | number:'1.2-2' }}</span>
              </div>
            </ng-container>
            <div *ngIf="calcExpertVisitAmount > 0" class="flex items-center justify-between text-[12px]">
              <span class="text-gray-600">Measurement Service <span class="text-gray-400">({{ serviceGstPer ? 'incl. ' + serviceGstPer + '% GST, ' : '' }}adjusted in this bill)</span></span>
              <span class="font-medium text-gray-900 tabular-nums transition-opacity" [class.opacity-50]="priceUpdating">₹{{ calcExpertVisitAmount | number:'1.2-2' }}</span>
            </div>
            <div class="flex items-center justify-between pt-1.5 border-t border-gray-200">
              <span class="text-[12px] font-bold text-gray-900 flex items-center gap-2">Total <span class="text-[10.5px] font-normal text-gray-400">incl. GST</span> <ng-container *ngTemplateOutlet="updatingTpl"></ng-container></span>
              <span class="font-bold text-gray-900 text-base tabular-nums transition-opacity" [class.opacity-50]="priceUpdating">{{ calcReady ? ('₹' + (calcTotal | number:'1.2-2')) : '—' }}</span>
            </div>
            <ng-container *ngTemplateOutlet="notIncludedTpl"></ng-container>
          </div>

          <div *ngIf="!priceLoading && selectedSizeType === 'SAMPLE'" class="border border-gray-200 rounded-lg px-4 py-3 flex items-center justify-between">
            <span class="text-sm text-gray-700">Sample</span>
            <span class="font-bold text-gray-900 text-base">₹{{ calculatedTotalPrice }}</span>
          </div>
        </div>

        
        <!-- Accordion: Add Installation -->
        <div *ngIf="selectedSizeType !== 'SAMPLE' && hasAnyWallDims">
          <button (click)="showInstallDetail = !showInstallDetail"
            class="w-full flex items-center justify-between py-2.5 text-left">
            <div class="flex items-center gap-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
              </svg>
              <span class="text-[11px] font-medium text-gray-800">Add Installation</span>
            </div>
            <div class="flex items-center gap-1.5 shrink-0">
              <span class="text-[11px] text-black-400">
                <ng-container *ngIf="installationIsFixed">₹{{ installationFixedAmount | number:'1.0-0' }}</ng-container>
                <ng-container *ngIf="!installationIsFixed && installationRate">₹{{ installationRate }}/sq.ft.</ng-container>
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                [style.transform]="showInstallDetail ? 'rotate(180deg)' : 'rotate(0deg)'" class="transition-transform duration-200 text-gray-400">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </div>
          </button>
          <div *ngIf="showInstallDetail" class="pb-3 space-y-2.5">
            <p class="text-[10px] text-gray-600 leading-relaxed">Our team installs the exact material you've ordered. Scheduled after your order is confirmed.</p>
            <button type="button" (click)="showInstallInfo = true"
              class="text-[10px] text-[#600b0b] underline hover:no-underline">How is installation charged?</button>

            <!-- "How is installation charged?" — values come from the pincode check, never hardcoded. -->
            <div *ngIf="showInstallInfo" class="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 p-4"
              (click)="showInstallInfo = false">
              <div class="w-full max-w-md rounded-lg bg-white p-5 shadow-xl" (click)="$event.stopPropagation()">
                <div class="flex items-start justify-between gap-3">
                  <h3 class="text-sm font-semibold text-gray-900">How is installation charged?</h3>
                  <button type="button" (click)="showInstallInfo = false" aria-label="Close"
                    class="text-gray-400 hover:text-gray-700 text-lg leading-none">&times;</button>
                </div>
                <ol class="mt-3 space-y-2 text-[12px] text-gray-700 list-decimal pl-4">
                  <li>We first check that installation is available at your pincode.</li>
                  <li>The areas of <b>all your walls</b> in this order are added together. Installation is charged
                    <b>once per order</b>, not per wall.</li>
                  <li *ngIf="installationFixedAmount && installationUptoSqft">
                    Total area <b>up to {{ installationUptoSqft }} sq.ft.</b> → fixed
                    <b>₹{{ installationFixedAmount | number:'1.0-0' }}</b>.<br />
                    Total area <b>above {{ installationUptoSqft }} sq.ft.</b> → total area ×
                    <b>{{ installationRate ? '₹' + installationRate + '/sq.ft.' : 'your city\'s rate per sq.ft.' }}</b>
                  </li>
                  <li *ngIf="!(installationFixedAmount && installationUptoSqft)">
                    Total area × {{ installationRate ? '₹' + installationRate + '/sq.ft.' : 'your city\'s rate per sq.ft.' }}<ng-container
                      *ngIf="installationFixedAmount">, with a minimum of <b>₹{{ installationFixedAmount | number:'1.0-0' }}</b></ng-container>
                  </li>
                </ol>
                <p *ngIf="installationArea > 0 && installationRate" class="mt-3 rounded-md bg-[#faf8f5] px-3 py-2 text-[12px] text-gray-700">
                  Your walls: <b>{{ installationArea | number:'1.0-2' }} sq.ft.</b> →
                  <b>{{ installationIsFixed
                    ? 'fixed ₹' + (installationFixedAmount | number:'1.0-0')
                    : '₹' + ((installationArea * installationRate) | number:'1.0-0') }}</b>
                </p>
                <p class="mt-3 text-[11px] text-gray-500">{{ serviceGstPer ? serviceGstPer + '% GST is added on top. ' : '' }}Enter your pincode to see the rate for your city.</p>
              </div>
            </div>
            <!-- Self Adhesive: no installation -->
            <div *ngIf="isSelfAdhesive" class="text-[10px] text-orange-600 bg-orange-50 px-2.5 py-1.5 rounded-md">
              Installation not available for Self Adhesive wallpapers.
            </div>
            <!-- Normal surfaces -->
            <ng-container *ngIf="!isSelfAdhesive">
              <div *ngIf="pincodeAvailable" class="space-y-2">
                <div class="flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1.5 rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  <span class="text-[10px] font-medium">{{ pincodeMessage }}</span>
                </div>
                <!-- Radio, not a checkbox: installation and an expert visit are
                     one choice, not two. The server rejects both on a line
                     (WallpaperCartRules), so offering both here could only ever
                     produce a 422. Both inputs share name="siteService". -->
                <label class="flex items-center gap-1.5 cursor-pointer select-none">
                  <input #installRadio type="radio" name="siteService" [checked]="wantInstallation"
                    (click)="onInstallationClick(installRadio)"
                    class="w-3.5 h-3.5 accent-[#600b0b] cursor-pointer" />
                  <span class="text-[10px] text-gray-700">Include installation in my order</span>
                </label>
                <button *ngIf="wantInstallation" type="button" (click)="chooseService('none')"
                  class="text-[10px] text-gray-500 underline hover:text-[#600b0b] transition-colors">
                  I don't need installation
                </button>
              </div>
              <!-- Shown unless installation is BOTH selected and verified. Gated on
                   `!wantInstallation` alone, a stale selection with no verified pincode hid
                   this form and the accordion rendered empty. -->
              <div *ngIf="!wantInstallation || !pincodeAvailable" class="space-y-2">
                <p class="text-[10px] text-gray-500">{{ pincodeAvailable ? 'Check a different pincode:' : 'Check if installation is available at your location.' }}</p>
                <div class="flex gap-1.5">
                  <input [ngModel]="pincode" (ngModelChange)="onPincodeChanged($event)"
                    type="text" inputmode="numeric" pattern="[0-9]*" placeholder="Enter pincode" maxlength="6"
                    (keyup.enter)="checkPincode()"
                    class="flex-1 border border-gray-300 rounded-md px-2.5 py-1.5 text-[11px] outline-none focus:border-[#600b0b] transition-colors" />
                  <button (click)="checkPincode()" [disabled]="pincodeChecking"
                    class="bg-white border border-gray-300 text-gray-700 px-3 py-1.5 rounded-md text-[10px] font-medium hover:border-[#600b0b] hover:text-[#600b0b] transition-all disabled:opacity-50">
                    {{ pincodeChecking ? '...' : 'Check' }}
                  </button>
                </div>
                <div *ngIf="pincodeMessage && !pincodeAvailable" class="text-[10px] text-red-500 flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                  <span>{{ pincodeMessage }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        </ng-container><!-- /!showSampleDetail -->

        <!-- Back button row — visible only when sample section is open -->
        <div *ngIf="showSampleDetail" class="flex justify-end pt-1 pb-0.5">
          <button (click)="showSampleDetail = false" class="flex items-center gap-1 text-[11px] text-gray-500 hover:text-[#600b0b] transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            Back
          </button>
        </div>

        <!-- Accordion: Book an Expert Visit — always visible (even when sample is open) -->
        <div *ngIf="!hasAnyWallDims">
          <button (click)="showExpertDetail = !showExpertDetail"
            class="w-full flex items-center justify-between py-2.5 text-left">
            <div class="flex items-center gap-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
              <span class="text-[11px] font-medium text-gray-800">Measurement Service</span>
            </div>
            <div class="flex items-center gap-1.5 shrink-0">
              <span class="text-[11px] text-black-400">{{ expertVisitFee ? '₹' + expertVisitFee : '' }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                [style.transform]="showExpertDetail ? 'rotate(180deg)' : 'rotate(0deg)'" class="transition-transform duration-200 text-gray-400">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </div>
          </button>
          <div *ngIf="showExpertDetail" class="pb-3 space-y-2.5">
            <p class="text-[10px] text-gray-600 leading-relaxed">Our expert comes to your home, measures your wall, and saves everything in your account. When you come back to order, your wall is already set up — you just pick your wallpaper.</p>
            <p class="text-[9px] text-[#600b0b] font-medium">{{ expertVisitFee ? '₹' + expertVisitFee : 'The visit fee' }} is adjusted in your wallpaper bill when you place your order.</p>

            <!-- After pincode verified: the OTHER half of the siteService radio
                 group. Picking this clears installation, and vice versa. -->
            <div *ngIf="expertPincodeAvailable" class="space-y-2">
              <div class="flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1.5 rounded-md">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                <span class="text-[10px] font-medium">Expert visit available at your pincode</span>
              </div>
              <label class="flex items-center gap-1.5 cursor-pointer select-none">
                <input #expertRadio type="radio" name="siteService" [checked]="wantExpertVisit"
                  (click)="onExpertVisitClick(expertRadio)"
                  class="w-3.5 h-3.5 accent-[#600b0b] cursor-pointer" />
                <span class="text-[10px] text-gray-700">Add Expert Visit{{ expertVisitFee ? ' (₹' + expertVisitFee + ')' : '' }} to my order</span>
              </label>
              <p *ngIf="wantInstallation" class="text-[9px] text-gray-500">
                Choosing an expert visit will remove installation — a visit measures a wall you haven't ordered yet.
              </p>
              <button *ngIf="wantExpertVisit" type="button" (click)="chooseService('none')"
                class="text-[10px] text-gray-500 underline hover:text-[#600b0b] transition-colors">
                I don't need an expert visit
              </button>
            </div>

            <!-- Before a pincode check, and re-shown the moment the visit is
                 deselected, so a different pincode can be tried. -->
            <div *ngIf="!wantExpertVisit || !expertPincodeAvailable" class="space-y-2">
              <p class="text-[10px] text-gray-500">{{ expertPincodeAvailable ? 'Check a different pincode:' : 'Enter your pincode to book the expert visit.' }}</p>
              <div class="flex gap-1.5">
                <input [(ngModel)]="expertPincode" type="text" inputmode="numeric" pattern="[0-9]*"
                  placeholder="Enter pincode" maxlength="6"
                  (keyup.enter)="checkPincodeAndBook()"
                  class="flex-1 border border-gray-300 rounded-md px-2.5 py-1.5 text-[11px] outline-none focus:border-[#600b0b] transition-colors" />
                <button (click)="checkPincodeAndBook()" [disabled]="expertPincodeChecking"
                  class="bg-white border border-gray-300 text-gray-700 px-3 py-1.5 rounded-md text-[10px] font-medium hover:border-[#600b0b] hover:text-[#600b0b] transition-all disabled:opacity-50 whitespace-nowrap">
                  {{ expertPincodeChecking ? 'Checking...' : 'Check' }}
                </button>
              </div>
              <div *ngIf="expertPincodeMessage" class="text-[10px] text-red-500 flex items-center gap-1">
                <svg class="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>
                {{ expertPincodeMessage }}
              </div>
            </div>

            <!-- Terms apply — always visible when expert detail open -->
            <div>
              <button (click)="showExpertTerms = !showExpertTerms"
                class="flex items-center gap-1 text-[10px] text-gray-400 hover:text-gray-600 transition-colors">
                <svg [style.transform]="showExpertTerms ? 'rotate(180deg)' : 'rotate(0deg)'"
                  class="w-2.5 h-2.5 transition-transform duration-200" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                *Terms apply
              </button>
                <!-- Both numbers come from the server (config/sales.expert_visit, via
                     /api/site/service/visit-terms). They were literals here, so a policy
                     change needed a frontend deploy. Hidden until they load — a stale
                     promise to the customer is worse than none. -->
              <div *ngIf="showExpertTerms && visitTerms"
                class="mt-2 text-[10px] text-gray-400 leading-relaxed bg-gray-50 rounded-lg px-3 py-2 border border-gray-100">
                Minimum wallpaper order value ₹{{ visitTerms.min_order_value | number:'1.0-0' }}. Order must be placed within {{ visitTerms.validity_months }} months of your visit date.
              </div>
            </div>
          </div>
        </div>

        <!-- Accordion: Order a Sample -->
        <div class="border-t border-gray-100">
          <button (click)="showSampleDetail = !showSampleDetail; showInstallDetail = false"
            class="w-full flex items-center justify-between py-3 text-left">
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                <line x1="12" y1="22.08" x2="12" y2="12"/>
              </svg>
              <span class="text-[11px] font-medium text-gray-800">Order a Sample</span>
            </div>
            <div class="flex items-center gap-2 shrink-0">
              <span class="text-[11px] text-black-400">from ₹{{ SAMPLE_BASE_PRICE }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                [style.transform]="showSampleDetail ? 'rotate(180deg)' : 'rotate(0deg)'" class="transition-transform duration-200 text-gray-400">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </div>
          </button>

          <div *ngIf="showSampleDetail" class="pb-5 space-y-4">
            <!-- Description -->
            <p class="text-[12px] text-gray-600 leading-relaxed">
              Not sure how the colour will look on your wall? Order a physical swatch — hold it against your wall, see it in your light. Once you are happy, come back and order the full wallpaper.
            </p>

            <!-- Choose Surfaces -->
            <div>
              <p class="text-[10px] font-semibold uppercase tracking-widest text-gray-500 mb-1">Choose your surfaces</p>
              <p class="text-[11px] text-gray-400 mb-3">First surface ₹{{ SAMPLE_BASE_PRICE }} · Each additional surface ₹{{ SAMPLE_EXTRA_PRICE }}</p>

              <div *ngIf="papers.length > 0; else loadingSurfaces" class="flex flex-wrap gap-2">
                <button *ngFor="let paper of papers" type="button"
                  (click)="toggleSampleSurface(paper)"
                  [ngClass]="{
                    'bg-[#600b0b] text-white border-[#600b0b]': isSampleSurfaceSelected(paper),
                    'border-gray-300 text-gray-700 hover:border-[#600b0b] hover:text-[#600b0b]': !isSampleSurfaceSelected(paper)
                  }"
                  class="px-3 py-1.5 rounded-full text-[11px] font-semibold border transition-all">
                  {{ paper.display_name || paper.name || paper.title }}
                </button>
              </div>

              <ng-template #loadingSurfaces>
                <div class="flex flex-wrap gap-2">
                  <div class="h-9 w-20 bg-gray-200 rounded-full animate-pulse"></div>
                  <div class="h-9 w-32 bg-gray-200 rounded-full animate-pulse"></div>
                  <div class="h-9 w-28 bg-gray-200 rounded-full animate-pulse"></div>
                  <div class="h-9 w-24 bg-gray-100 rounded-full animate-pulse"></div>
                </div>
              </ng-template>
            </div>

            <!-- Summary + Order Button -->
            <div class="space-y-2 pt-1">
              <div class="flex items-center justify-between text-[12px]">
                <span class="text-gray-500">
                  <ng-container *ngIf="selectedSampleSurfaceIds.size > 0">
                    {{ selectedSampleSurfaceIds.size }} surface{{ selectedSampleSurfaceIds.size > 1 ? 's' : '' }} selected
                  </ng-container>
                  <ng-container *ngIf="selectedSampleSurfaceIds.size === 0">Select surfaces above</ng-container>
                </span>
                <span *ngIf="selectedSampleSurfaceIds.size > 0" class="font-semibold text-gray-800">₹{{ sampleTotalPrice }}</span>
              </div>
              <button (click)="orderSample()"
                [disabled]="selectedSampleSurfaceIds.size === 0 || addingSample"
                class="w-full py-3 rounded-full text-[11px] font-semibold uppercase tracking-[0.14em] transition-all flex items-center justify-center gap-2"
                [class]="selectedSampleSurfaceIds.size > 0
                  ? 'bg-[#600b0b] text-white hover:bg-[#8c1c1c] disabled:opacity-60'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'">
                <span *ngIf="addingSample">Adding...</span>
                <span *ngIf="!addingSample && selectedSampleSurfaceIds.size > 0">Order Sample · ₹{{ sampleTotalPrice }}</span>
                <span *ngIf="!addingSample && selectedSampleSurfaceIds.size === 0">Select a surface to order</span>
              </button>
            </div>
          </div>
        </div>




        <!-- ADD TO CART — hidden on desktop while sample panel is open, kept on mobile -->
        <div *ngIf="!showSampleDetail || isMobile" class="py-3">
          <button (click)="addToCart()" (mouseenter)="onAddCartHoverIn()" (mouseleave)="onAddCartHoverOut()" [disabled]="addingToCart || hasWallQuoteErrors"
            class="w-full bg-[#600b0b] text-white py-3 rounded-full text-[11px] uppercase tracking-[0.15em] hover:bg-[#8c1c1c] transition-all disabled:opacity-50 flex items-center justify-center gap-2">
            <span *ngIf="addingToCart">Adding...</span>
            <span *ngIf="!addingToCart">Add to Cart</span>
          </button>

          <!-- BUY NOW -->
          <button (click)="buyNow()" [disabled]="addingToCart || buyingNow || hasWallQuoteErrors"
            class="w-full mt-2 bg-[#c49a6c] text-[#1a0505] py-3 rounded-full text-[11px] uppercase tracking-[0.15em] hover:bg-[#d4aa7c] transition-all disabled:opacity-50 flex items-center justify-center gap-2">
            <span *ngIf="buyingNow">Processing...</span>
            <span *ngIf="!buyingNow">Buy Now</span>
          </button>
        </div>



      </div>

      <!-- ═══ Tabs: Details / Specs / Care (3rd grid item) ═══ -->
      <!-- Mobile: shows after purchase panel | Desktop: shows below images in col-1 -->
      <div class="border-t border-gray-200 pt-1 min-w-0 overflow-hidden">
        <div class="flex gap-0 border-b border-gray-200">
          <button (click)="activeTab = 'specs'"
            [class]="'px-4 md:px-6 py-2.5 text-[11px] md:text-xs font-bold uppercase tracking-wider border-b-2 transition-all ' + (activeTab === 'specs' ? 'border-[#600b0b] text-[#600b0b]' : 'border-transparent text-gray-500 hover:text-gray-700')">
            Surfaces
          </button>
          <button (click)="activeTab = 'details'"
            [class]="'px-4 md:px-6 py-2.5 text-[11px] md:text-xs font-bold uppercase tracking-wider border-b-2 transition-all ' + (activeTab === 'details' ? 'border-[#600b0b] text-[#600b0b]' : 'border-transparent text-gray-500 hover:text-gray-700')">
            Details
          </button>
          <button (click)="activeTab = 'care'"
            [class]="'px-4 md:px-6 py-2.5 text-[11px] md:text-xs font-bold uppercase tracking-wider border-b-2 transition-all ' + (activeTab === 'care' ? 'border-[#600b0b] text-[#600b0b]' : 'border-transparent text-gray-500 hover:text-gray-700')">
            Care
          </button>
        </div>
        <div class="py-3 md:py-4 text-sm text-gray-600 leading-relaxed">
          <div *ngIf="activeTab === 'details'">
            <h3 class="text-xl md:text-2xl lg:text-3xl font-medium text-gray-900 leading-[1.1] mb-1"
              style="font-family: 'Roboto Slab', serif;">{{ wallpaper.name }}</h3>
            <span *ngIf="wallpaperId" class="text-[10px] uppercase tracking-[0.15em] text-gray-400">SKU: {{ wallpaperId }}</span>
            <p *ngIf="description" class="text-sm md:text-base text-gray-700 leading-relaxed mb-4 mt-2">{{ description }}</p>
            <p *ngIf="!description" class="text-gray-400 mb-4">No description available.</p>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2.5 text-[13px]">
              <div *ngIf="detailSpaces" class="flex gap-3">
                <span class="font-bold text-gray-900 uppercase tracking-wider text-[11px] shrink-0 w-20">Spaces:</span>
                <span class="text-gray-600">{{ detailSpaces }}</span>
              </div>
              <div *ngIf="detailMoods" class="flex gap-3">
                <span class="font-bold text-gray-900 uppercase tracking-wider text-[11px] shrink-0 w-20">Moods:</span>
                <span class="text-gray-600">{{ detailMoods }}</span>
              </div>
              <div *ngIf="resolvedColors.length > 0" class="flex gap-3 items-center">
                <span class="font-bold text-gray-900 uppercase tracking-wider text-[11px] shrink-0 w-20">Color:</span>
                <span class="text-gray-600">{{ colorNames }}</span>
              </div>
              <div *ngIf="collectionName" class="flex gap-3">
                <span class="font-bold text-gray-900 uppercase tracking-wider text-[11px] shrink-0 w-20">Collection:</span>
                <span class="text-gray-600 capitalize">{{ collectionName }}</span>
              </div>
              <div *ngIf="wallpaperType" class="flex gap-3">
                <span class="font-bold text-gray-900 uppercase tracking-wider text-[11px] shrink-0 w-20">Type:</span>
                <span class="text-gray-600 capitalize">{{ wallpaperType }}</span>
              </div>
            </div>
          </div>
          <div *ngIf="activeTab === 'specs'" #surfacesTab>
            <p class="text-xs md:text-sm font-extrabold uppercase tracking-[0.2em] text-gray-700 mb-1 flex items-center gap-1.5">
              <span class="text-[#600b0b]">◈</span> Choose Your Surface
            </p>
            <p class="text-xs text-gray-500 mb-3">Each surface has a different feel, finish, and price. Choose what works best for your wall.</p>
            <div *ngIf="!papersLoaded" class="flex flex-wrap gap-2 mb-4">
              <div class="h-9 w-20 bg-gray-200 rounded-full animate-pulse"></div>
              <div class="h-9 w-28 bg-gray-200 rounded-full animate-pulse"></div>
              <div class="h-9 w-24 bg-gray-200 rounded-full animate-pulse"></div>
              <div class="h-9 w-24 bg-gray-200 rounded-full animate-pulse"></div>
              <div class="h-9 w-28 bg-gray-100 rounded-full animate-pulse"></div>
              <div class="h-9 w-20 bg-gray-100 rounded-full animate-pulse"></div>
            </div>
            <div *ngIf="papersLoaded" class="flex flex-wrap gap-2 mb-4">
              <button *ngFor="let paper of papers"
                (click)="selectPaper(paper)"
                (mouseenter)="hoveredPaperId = paper.id"
                (mouseleave)="hoveredPaperId = null"
                [ngClass]="{
                  'shadow-md': hoveredPaperId === paper.id,
                  'bg-[#600b0b] text-white border-[#600b0b]': selectedPaper?.id === paper.id,
                  'border-gray-300 text-gray-700 hover:border-[#600b0b] hover:text-[#600b0b]': selectedPaper?.id !== paper.id
                }"
                class="group/surf relative inline-flex items-center justify-center px-3 md:px-4 py-1.5 md:py-2 rounded-full text-[10px] md:text-xs font-semibold border overflow-hidden transition-all duration-300 ease-out">
                <span class="pointer-events-none absolute inset-0 -translate-x-full group-hover/surf:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-[#c49a6c]/30 to-transparent"></span>
                <span class="relative">{{ paper.display_name || paper.name || paper.title }}</span>
                <span *ngIf="hoveredPaperId === paper.id && getPaperImage(paper)"
                  class="surface-img-anim relative ml-1.5 inline-block shrink-0">
                  <img [src]="getPaperImage(paper)" [alt]="paper.display_name || paper.name"
                    class="w-[50px] h-4 md:h-5 rounded-sm object-cover border border-white/40" />
                </span>
              </button>
            </div>
            <div *ngIf="selectedSurfaceSpec as spec" class="pt-1 border-t border-gray-100 mt-2">
              <p class="text-[11px] md:text-[13px] font-bold uppercase tracking-wider text-black mb-1">{{ selectedPaper?.display_name || selectedPaper?.name }}</p>
              <ng-container *ngIf="selectedSurfaceExtra as extra">
                <p class="text-[11px] md:text-sm italic text-gray-500 mb-1.5">{{ extra.tagline }}</p>
                <div class="flex flex-wrap gap-1.5 mb-2">
                  <span class="text-[9px] md:text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 bg-gray-100 text-gray-600 rounded border border-gray-200">{{ extra.install }}</span>
                  <span class="text-[9px] md:text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 bg-gray-100 text-gray-600 rounded border border-gray-200">{{ extra.price }}</span>
                </div>
              </ng-container>
              <div class="flex gap-2 items-start">
                <table class="text-[11px] md:text-sm border border-gray-200 flex-1">
                  <tbody>
                    <tr class="border-b border-gray-100">
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-500 font-medium bg-gray-50 w-[90px] md:w-[120px]">Thickness</td>
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-800">{{ spec.thickness }}</td>
                    </tr>
                    <tr class="border-b border-gray-100">
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-500 font-medium bg-gray-50">Material</td>
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-800">{{ spec.material }}</td>
                    </tr>
                    <tr class="border-b border-gray-100">
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-500 font-medium bg-gray-50">Finish</td>
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-800">{{ spec.finish }}</td>
                    </tr>
                    <tr class="border-b border-gray-100">
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-500 font-medium bg-gray-50">Water</td>
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-800">{{ spec.water }}</td>
                    </tr>
                    <tr>
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-500 font-medium bg-gray-50">Features</td>
                      <td class="py-1 px-2 md:py-2 md:px-3 text-gray-800">{{ spec.etc }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="shrink-0 rounded-md overflow-hidden border border-gray-200 bg-[#f5f0eb] shadow-sm w-[80px] md:w-[200px] aspect-square">
                  <img *ngIf="surfaceHoverImage" [src]="surfaceHoverImage"
                    [alt]="selectedPaper?.display_name || selectedPaper?.name || wallpaper?.name"
                    class="w-full h-full object-cover" />
                  <div *ngIf="!surfaceHoverImage" class="w-full h-full flex items-center justify-center text-gray-400 text-xs">No preview</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="activeTab === 'care'">
            <ul class="space-y-2.5 text-sm text-gray-700 leading-relaxed list-disc pl-5">
              <li>Easy to clean with a soft damp cloth</li>
              <li>Avoid harsh chemicals or abrasive scrubbing</li>
              <li>Apply on smooth, clean, dry, painted walls</li>
              <li>Long-lasting finish with minimal maintenance</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Similar Products — placeholders while the rail resolves (it can take up to
         three requests), so the section holds its space instead of appearing late
         and pushing the page down under the reader. -->
    <div *ngIf="similarLoading" class="mt-10 md:mt-16">
      <div class="h-6 w-40 bg-gray-200 rounded animate-pulse mb-1"></div>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mb-4 md:mb-6"></div>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        <app-card-skeleton [count]="similarCount" aspect="1 / 1" [showText]="false"></app-card-skeleton>
      </div>
    </div>

    <div *ngIf="!similarLoading && similarWallpapers.length > 0" class="mt-10 md:mt-16">
      <h2 class="text-xl md:text-2xl font-medium text-gray-900 mb-1" style="font-family: 'Roboto Slab', serif;">
        Similar Wallpaper</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mb-4 md:mb-6"></div>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        <div *ngFor="let wp of similarWallpapers" (click)="navigateToPDP(wp)" class="group cursor-pointer">
          <div class="relative aspect-square rounded-lg md:rounded-xl overflow-hidden shadow-sm group-hover:shadow-lg transition-all">
            <!-- Image -->
            <img [src]="wp.list_thumbnail" [alt]="wp.name"
              class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />

            <!-- Top gradient overlay — hover only -->
            <div class="absolute top-0 left-0 right-0 h-16 md:h-20 bg-gradient-to-b from-black/70 via-black/40 to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-[5]"></div>

            <!-- Top-right action buttons — hover only -->
            <div class="absolute top-2 right-2 flex flex-col gap-1.5 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <!-- Wishlist -->
              <button (click)="$event.stopPropagation(); toggleWishlistItem(wp, $event)"
                class="w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all hover:scale-110"
                [class.text-white]="!isItemWishlisted(wp.id.toString())"
                [class.text-red-500]="isItemWishlisted(wp.id.toString())">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                  [attr.fill]="isItemWishlisted(wp.id.toString()) ? 'currentColor' : 'none'" stroke="currentColor"
                  stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </button>
              <!-- View / Expand -->
              <button (click)="$event.stopPropagation(); navigateToPDP(wp)"
                class="w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all text-white hover:scale-110"
                title="View Product">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" />
                </svg>
              </button>
            </div>

            <!-- Bottom gradient with name/price -->
            <div class="absolute bottom-0 left-0 right-0 px-2.5 md:px-3 pt-10 pb-1 md:pb-1.5 bg-gradient-to-t from-black/70 via-black/40 to-transparent" style="text-shadow: 0 1px 3px rgba(0,0,0,0.6);">
              <div class="flex items-center justify-between gap-2">
                <div class="relative flex-1 min-w-0">
                  <h3 class="font-bold text-white text-[11px] md:text-[13px] truncate leading-tight transition-transform duration-300 ease-out group-hover:-translate-y-[130%]"
                    style="font-family: 'Roboto', sans-serif;">{{ wp.name }}</h3>
                  <p class="absolute inset-0 text-white/85 text-[10px] md:text-[11px] font-normal tracking-wide truncate translate-y-full opacity-0 transition-all duration-300 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                    {{ wp.wallpaper_id }}</p>
                </div>
                <!-- Hidden, not zeroed, when no surface can be priced: a bare "₹"
                     or a "₹0/sq.ft" advertises a free wall. -->
                <span *ngIf="wp.price" class="font-bold text-white text-[10px] md:text-[12px] shrink-0">₹{{ wp.price | number:'1.0-2' }}<span class="font-normal text-white/80 text-[9px] md:text-[10px]">/sq.ft</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Crop Pattern Modal -->
<div *ngIf="isCropModalOpen"
  style="position:fixed;inset:0;z-index:999998;background:rgba(0,0,0,0.85);display:flex;align-items:center;justify-content:center;padding:16px;"
  (click)="closeCropModal()">
  <div (click)="$event.stopPropagation()"
    style="background:white;border-radius:20px;width:100%;max-width:560px;overflow:hidden;box-shadow:0 32px 80px rgba(0,0,0,0.6);">

    <!-- Header -->
    <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #f0f0f0;">
      <div>
        <p style="font-size:14px;font-weight:700;color:#111;margin:0;">Pattern Crop Preview</p>
        <p style="font-size:11px;color:#888;margin:4px 0 0;">
          Wall: {{ patternPreviewLabel.w }} × {{ patternPreviewLabel.h }} &nbsp;·&nbsp; Drag corners to resize crop
        </p>
      </div>
      <button (click)="closeCropModal()"
        style="width:32px;height:32px;border-radius:50%;border:none;background:#f5f5f5;cursor:pointer;display:flex;align-items:center;justify-content:center;">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#666" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- ngx-image-cropper -->
    <div style="background:#1a1a1a;max-height:420px;overflow:hidden;">
      <image-cropper
        [imageURL]="cropPatternImage"
        [maintainAspectRatio]="true"
        [aspectRatio]="cropAspectRatio"
        [roundCropper]="false"
        [canvasRotation]="0"
        format="jpeg"
        outputType="base64"
        backgroundColor="#1a1a1a"
        (imageCropped)="onImageCropped($event)"
        (cropperReady)="cropperReady = true"
        style="max-height:420px;">
      </image-cropper>
    </div>

    <!-- Cropped preview + info -->
    <div style="padding:14px 20px;background:#fafafa;display:flex;align-items:center;gap:14px;">
      <img *ngIf="croppedImageBase64" [src]="croppedImageBase64"
        style="width:60px;height:60px;object-fit:cover;border-radius:8px;border:1px solid #e0e0e0;" />
      <div>
        <p style="font-size:12px;font-weight:600;color:#333;margin:0;">
          {{ patternPreviewLabel.w }} × {{ patternPreviewLabel.h }}
        </p>
        <p style="font-size:11px;color:#999;margin:4px 0 0;">
          Aspect ratio locked to your wall dimensions
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Installation Agreement Modal -->
<app-installation-modal [isOpen]="showInstallationModal"
  (agreed)="closeInstallationModal()"
  (cancelled)="declineInstallationModal()">
</app-installation-modal>

<!-- Lightbox -->
<div *ngIf="isLightboxOpen"
  style="position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:999999;background:rgba(0,0,0,0.95);"
  (click)="closeLightbox()">

  <!-- Close button -->
  <button (click)="closeLightbox()"
    style="position:fixed;top:16px;right:16px;z-index:1000001;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.25);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background 0.2s;"
    onmouseenter="this.style.background='rgba(255,255,255,0.3)'"
    onmouseleave="this.style.background='rgba(255,255,255,0.15)'">
    <svg xmlns="http://www.w3.org/2000/svg" style="width:20px;height:20px;color:white;" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="2.5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
    </svg>
  </button>

  <!-- Counter -->
  <div style="position:fixed;top:20px;left:16px;z-index:1000001;background:rgba(0,0,0,0.5);color:rgba(255,255,255,0.8);font-size:12px;font-weight:600;padding:6px 14px;border-radius:20px;pointer-events:none;">
    {{ activeImageIndex + 1 }} / {{ images.length }}
  </div>

  <!-- Main image — truly centered -->
  <div style="position:fixed;top:0;left:0;width:100vw;height:calc(100vh - 70px);display:flex;align-items:center;justify-content:center;padding:44px 4px 4px;"
    (click)="$event.stopPropagation()">
    <img [src]="activeImage" [alt]="wallpaper?.name"
      style="max-width:calc(100vw - 8px);max-height:calc(100vh - 118px);width:auto;height:auto;border-radius:8px;box-shadow:0 25px 60px rgba(0,0,0,0.6);" />
  </div>

  <!-- Prev arrow -->
  <button *ngIf="images.length > 1" (click)="prevImage(); $event.stopPropagation()"
    style="position:fixed;left:16px;top:50%;transform:translateY(-50%);z-index:1000001;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,0.12);border:1px solid rgba(255,255,255,0.2);display:flex;align-items:center;justify-content:center;cursor:pointer;"
    onmouseenter="this.style.background='rgba(255,255,255,0.25)'"
    onmouseleave="this.style.background='rgba(255,255,255,0.12)'">
    <svg xmlns="http://www.w3.org/2000/svg" style="width:20px;height:20px;" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
  </button>

  <!-- Next arrow -->
  <button *ngIf="images.length > 1" (click)="nextImage(); $event.stopPropagation()"
    style="position:fixed;right:16px;top:50%;transform:translateY(-50%);z-index:1000001;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,0.12);border:1px solid rgba(255,255,255,0.2);display:flex;align-items:center;justify-content:center;cursor:pointer;"
    onmouseenter="this.style.background='rgba(255,255,255,0.25)'"
    onmouseleave="this.style.background='rgba(255,255,255,0.12)'">
    <svg xmlns="http://www.w3.org/2000/svg" style="width:20px;height:20px;" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
  </button>

  <!-- Thumbnail strip -->
  <div style="position:fixed;bottom:0;left:0;right:0;z-index:1000001;height:70px;background:rgba(0,0,0,0.7);display:flex;align-items:center;justify-content:center;gap:8px;padding:0 16px;overflow-x:auto;"
    (click)="$event.stopPropagation()">
    <div *ngFor="let img of images; let i = index" (click)="changeActiveImage(i)"
      style="flex-shrink:0;cursor:pointer;border-radius:6px;overflow:hidden;transition:transform 0.15s;"
      [style.border]="activeImageIndex === i ? '2px solid white' : '2px solid rgba(255,255,255,0.2)'"
      [style.transform]="activeImageIndex === i ? 'scale(1.08)' : 'scale(1)'">
      <img [src]="img" [alt]="wallpaper?.name" style="width:56px;height:40px;object-fit:cover;display:block;" />
    </div>
  </div>

</div>